import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={15}
    height={9}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.65 7.247v-1.2h.45c.485 0 .9-.416.9-.9v-2.1c0-.485-.415-.9-.9-.9h-.45v-1.2c0-.484-.416-.9-.9-.9h-12c-.485 0-.75.45-.75.934v6.232c0 .485.265.934.75.934h12c.484 0 .9-.415.9-.9Zm-12.45 0c-.044 0-.15-.106-.15-.15v-5.85c0-.044.106-.15.15-.15h11.25c.044 0 .15.106.15.15v5.85c0 .044-.106.15-.15.15H1.2Zm.15-5.85v5.55h2.378V1.433L1.35 1.397Z"
      fill="#636F7C"
    />
    <path
      d="M7.511 2.41v1.986l-3.225-.93 4.275 3.23V4.708l3.225.93-4.275-3.23Z"
      fill="#636F7C"
    />
  </svg>
)

export default SvgComponent